module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABVUlEQVRYR+2YT0rDQBSH3zOpuYRd24ULu3RrmtBcoCXWtfQWOYbiWg30AoGmuhHBVVtwoXu9RJs/T4IIRSbEmUkk4Ms285v55ktmhnkILX+w5XxQCjgcnh8maXIFSCdEYDUxEUTYEMCzicZ0Pg/fRGOUAtqD8ZKA+k2A/ewTEdb38Uw4Ving6WBEMnAI8EII268MWkB0JJN/WMyELLUBysCI2moDGmicxXEY6oIUedsdTyinm92+tAHLOlABDoJg7/HpNWNAFXtFhg2qmvvOsUE2uGPg1ycJ74O6ZzEbZIMSew9v1BKyhE3ZIBvko67iH/ifi6TOa6fj+H5G2V2ttzrdlVuV174XVw2g+75xQESM9k3zogDdpuk1EXky0I0DWp1ON4puPwooz5scbJLknQFlDPz5J7ad0YoIjmUgVdsqFTBd1+9leX7Z2hKwqo26c62v8n8CJwR5OLs9Jl4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/icon_phone.png
// module id = 622
// module chunks = 0